const renderMoreSelectedValues = (omittedValues) => `+${omittedValues.length}`;

export const multiSelectTagProps = {
  maxTagCount: 1,
  maxTagPlaceholder: renderMoreSelectedValues,
};
